export enum TimeslotViewMode {
    Reservation = "Reservation",
    Blocking = "Blocking",
    Editing = "Editing",
}
